export enum ShiftTypeEnum {
	ALL = '',
	MORNING = 'M',
	AFTERNOON = 'T',
	NIGHT = 'N',
}
